/**
 * Utilitários para gerenciar menções no sistema @[Nome](user:UUID)
 */

const MENTION_REGEX = /@\[([^\]]+)\]\(user:([0-9a-fA-F-]{36})\)/g;
export const MENTION_SPLIT_REGEX = /(@\[[^\]]+\]\(user:[0-9a-fA-F-]{36}\))/g;

/**
 * Extrai IDs únicos de usuários mencionados em um texto formatado
 */
export const extractMentionedUserIds = (text: string): string[] => {
  if (!text) return [];
  const matches = [...text.matchAll(MENTION_REGEX)];
  const ids = matches.map(match => match[2]);
  const uniqueIds = [...new Set(ids)];
  return uniqueIds;
};

/**
 * Converte markup @[Nome](user:UUID) para @Nome (exibição humana)
 */
export const stripMentionMarkup = (text: string): string => {
  if (!text) return '';
  return text.replace(MENTION_REGEX, '@$1');
};

/**
 * Converte texto humano de volta para markup usando um mapa de usuários conhecidos
 */
export const buildStoredText = (displayText: string, mentions: {id: string, name: string}[]): string => {
  let storedText = displayText;
  // Ordenar por tamanho do nome (desc) para evitar substituir "Felipe Silva" antes de "Felipe"
  const sortedMentions = [...mentions].sort((a, b) => b.name.length - a.name.length);
  
  sortedMentions.forEach(user => {
    const mentionTrigger = `@${user.name}`;
    // Usamos uma substituição cuidadosa para não duplicar se já estiver formatado (embora no input não deva estar)
    const escapedName = user.name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`@${escapedName}\\b`, 'g');
    storedText = storedText.replace(regex, `@[${user.name}](user:${user.id})`);
  });
  
  return storedText;
};

/**
 * Extrai a lista de objetos de menção de um texto formatado
 */
export const parseStoredMentions = (text: string): {id: string, name: string}[] => {
  if (!text) return [];
  const matches = [...text.matchAll(MENTION_REGEX)];
  return matches.map(m => ({ name: m[1], id: m[2] }));
};

export const getMentionName = (part: string): string | null => {
  const match = part.match(/@\[([^\]]+)\]\(user:[0-9a-fA-F-]{36}\)/);
  return match ? match[1] : null;
};
